import { render, staticRenderFns } from "./CalendarEventEditorStartEnd.vue?vue&type=template&id=4876efd8&scoped=true&lang=pug&"
import script from "./CalendarEventEditorStartEnd.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorStartEnd.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventEditorStartEnd.vue?vue&type=style&index=0&id=4876efd8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876efd8",
  null
  
)

export default component.exports